'use strict';

var HTML_VOID_ELEMENTS = [
  'area','base','br','col','command','embed','hr','img',
  'input','keygen','link','meta','param','source','track','wbr'
];

module.exports = HTML_VOID_ELEMENTS;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/var/HTML_VOID_ELEMENTS.js
// module id = 980
// module chunks = 0